import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, QueryList, ViewChildren } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModalComponent } from '../questions/modal/modal.component';
import { LikertComponent } from '../questions/likert/likert.component';
import { IQuestionComponent } from '../questions/question.model';
import { QUESTIONS } from '../questions/questions.token';
import { SectionComponent } from '../questions/section/section.component';
import { TextareaComponent } from '../questions/textarea/textarea.component';
import { getQuestionParams } from '../question.helper';
import { TextboxComponent } from '../questions/textbox/textbox.component';
import { Card } from '@jump-tech-frontend/domain';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'question-card-to-questions',
  template: `
    @if (card?.questions?.length && (params$ | async); as params) {
      @for (question of card.questions; track question) {
        @switch (question.controlType) {
          @case ('Modal') {
            <question-modal [params]="params[question.key]"></question-modal>
          }
          @case ('Likert') {
            <question-likert [params]="params[question.key]"></question-likert>
          }
          @case ('TextareaQuestion') {
            <question-textarea [params]="params[question.key]"></question-textarea>
          }
          @case ('Section') {
            <question-section
              [label]="question.label"
              [hint]="question.hint ?? ''"
            ></question-section>
          }
          @case ('Textbox') {
            <question-textbox [params]="params[question.key]"></question-textbox>
          }
        }
      }
    }
    `,
  imports: [CommonModule, ModalComponent, LikertComponent, TextareaComponent, SectionComponent, TextboxComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardToQuestionsComponent implements OnChanges {
  @Input() card: Card<string>;
  @Input() form: FormGroup;

  @ViewChildren(QUESTIONS) questions: QueryList<IQuestionComponent>;

  params$ = new BehaviorSubject<unknown>(null);

  ngOnChanges(): void {
    const params: { [key: string]: unknown } = {};
    for (const question of this.card.questions ?? []) {
      const currentQuestionValue = this.form.get(question.key)?.value;
      params[question.key] = getQuestionParams(question, currentQuestionValue);
    }
    this.params$.next(params);
  }
}
